export interface PasswordValidationErrors {
    oldPassword?: string;
    password: string;
    confirmPassword: string;
}

interface ValidatePasswordOptions {
    requireOldPassword?: boolean;
}

export const validatePasswordFields = (
    oldPassword: string | undefined,
    password: string,
    confirmPassword: string,
    options: ValidatePasswordOptions = {}
): PasswordValidationErrors => {
    const errors: PasswordValidationErrors = { password: '', confirmPassword: '' };

    if (options.requireOldPassword) {
        if (!oldPassword) errors.oldPassword = 'Stare hasło jest wymagane';
    }

    if (!password) errors.password = 'Hasło jest wymagane';
    else if (password.length < 8) errors.password = 'Hasło musi mieć minimum 8 znaków';
    else if (!(/[A-Z]/).test(password)) errors.password = 'Hasło musi zawierać co najmniej jedną dużą literę';
    else if (!(/\d/).test(password)) errors.password = 'Hasło musi zawierać co najmniej jedną cyfrę';

    if (password !== confirmPassword) errors.confirmPassword = 'Hasła nie są identyczne';

    return errors;
};
